import React, { useEffect, useState, useCallback } from 'react'
import { Card, Grid, Divider, Button, TextField, Checkbox, FormControlLabel } from '@material-ui/core/'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'
import ThaiDateFnsUtils from '../../../../../utils/ThaiDateFnsUtils'
import AccountCircle from '@material-ui/icons/AccountCircle';
import Home from '@material-ui/icons/Home';
import AccountBox from '@material-ui/icons/AccountBox';
import Business from '@material-ui/icons/Business';
import Work from '@material-ui/icons/Work';
import Mail from '@material-ui/icons/Mail';
import Phone from '@material-ui/icons/Phone';
import PhoneInTalk from '@material-ui/icons/PhoneInTalk';
import CalendarToday from '@material-ui/icons/CalendarToday';
import EventBusy from '@material-ui/icons/EventBusy';
import Sms from '@material-ui/icons/Sms';

import { operators, admin } from '../../../../../api/'

import { useParams, useHistory } from 'react-router-dom'
import { useStoreRehydrated } from '../../../../../store'

import SuccessModal from 'components/modal/SuccessModal'
import FailModal from 'components/modal/FailModal'

export default function OrganizationEdit() {
	const { id } = useParams()
	const history = useHistory()
	const isRehydrated = useStoreRehydrated()
	const [organizationData, setOrganizationData] = useState({
		companyName: '',
		companyAddress: '',
		companyStatus: '',
		email: '',
		telephoneNumber: '',
		mobileNumber: '',
		smsTelephone: '',
		apiToken: '',
		isPayphone: null,
		operatorQOS: [],
		isUseReport1_1_2: false,
	})
	const [tempAPIToken, setTempAPIToken] = useState('')
	const [openFailModal, setOpenFailModal] = useState(false)
	const [failMessage, setFailMessage] = useState('')
	const [openSuccessModal, setOpenSuccessModal] = useState(false)

	const [email, setEmail] = useState('')
	const [telephone, setTelephone] = useState('')
	const [smsTelephone, setSmsTelephone] = useState('')
	const [isUseReport1_1_2, setIsUseReport1_1_2] = useState(false)
	const [selectedQOS, setSelectedQOS] = useState([])
	const [allQOSTypes, setAllQOSTypes] = useState([])
	const [startDate, setStartDate] = useState(null)
	const [endDate, setEndDate] = useState(null)

	const onOpenSuccessModal = () => {
		setOpenSuccessModal(!openSuccessModal)
		if (!openSuccessModal) {
			// Redirect back to list or stay?
		}
	}

	const onOpenFailModal = () => {
		setOpenFailModal(!openFailModal)
	}

	const onSubmitChange = async () => {
		const res = await admin.updateOperatorInfo(id, telephone, email, smsTelephone, isUseReport1_1_2, selectedQOS, startDate, endDate, organizationData.isPayphone)
		if (res.status === 200) {
			onOpenSuccessModal()
		} else {
			setFailMessage(res?.data?.message || res?.response?.data?.message || 'เกิดข้อผิดพลาด')
			onOpenFailModal()
		}
		getOrganizationData()
	}

	const getOrganizationData = useCallback(async () => {
		const res = await operators.getOrganizationDataID(id)
		const status = res.status
		const data = res.data
		if (status === 200) {
			// Logic to select appropriate OperatorInfo (Branch "00000" or first)
			let opInfo = data.operatorInfos;
			if (Array.isArray(opInfo)) {
				opInfo = opInfo.find(i => i.branchNo === '00000') || opInfo[0] || {};
			}

			let organizationDataTemp = {
				companyName: data.operatorName,
				companyAddress: `${opInfo.addr} ${opInfo.postCode ?? ''}`,
				companyStatus: 'ดำเนินกิจการอยู่',
				email: opInfo.email,
				telephoneNumber: opInfo.telephone,
				mobileNumber: opInfo.mobile,
				smsTelephone: opInfo.smsTelephone,
				apiToken: data.apiToken,
				isPayphone: data.isPayphone,
				operatorQOS: data.operatorQOS,
				isUseReport1_1_2: data.isUseReport1_1_2,
			}
			setTempAPIToken(data.apiToken)
			setOrganizationData(organizationDataTemp)

			// Set form values
			setEmail(opInfo.email)
			setTelephone(opInfo.mobile)
			setSmsTelephone(opInfo.smsTelephone)
			setIsUseReport1_1_2(data.isUseReport1_1_2)
			setSelectedQOS(data.operatorQOS.map(q => q.qosTypeID))
			setStartDate(data.startDate)
			setEndDate(data.endDate)
		}
	}, [id])

	useEffect(() => {
		const fetchQOSTypes = async () => {
			const res = await operators.getQOSTypes()
			if (res.status === 200) {
				setAllQOSTypes(res.data)
			}
		}
		fetchQOSTypes()
	}, [])

	useEffect(() => {
		if (isRehydrated) getOrganizationData()
		// eslint-disable-next-line
	}, [isRehydrated])

	const onValueChange = (value, type) => {
		if (type === 'email') {
			setEmail(value)
		} else if (type === 'telephone') {
			setTelephone(value)
		} else if (type === 'smsTelephone') {
			setSmsTelephone(value)
		} else if (type === 'isUseReport1_1_2') {
			setIsUseReport1_1_2(value)
		} else if (type === 'operatorQOS') {
			const currentIndex = selectedQOS.indexOf(value)
			const newChecked = [...selectedQOS]

			if (currentIndex === -1) {
				newChecked.push(value)
			} else {
				newChecked.splice(currentIndex, 1)
			}
			setSelectedQOS(newChecked)
		} else if (type === 'isPayphone') {
			setOrganizationData({ ...organizationData, isPayphone: value })
		}
	}

	return (
		<>
			<Grid className="p-10 ">
				<Card className={`border-t-4 border-card_top_border`}>
					<Grid className="flex flex-col justify-center items-start px-5">
						<Grid className="flex flex-row mt-4 items-center justify-between w-full">
							<Grid className="flex flex-row">
								<AccountCircle style={{ fontSize: 22 }} className="mr-1" />
								<Grid className="font-bold text-sm text-card_header_color">
									แก้ไขข้อมูลผู้ประกอบการ
								</Grid>
							</Grid>
						</Grid>
						<Grid className="mt-3 mb-1 w-full">
							<Divider />
						</Grid>

						{/* Read-only Info */}
						{/* Company Name */}
						<Grid
							className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-text_field_bg`}>
							<Grid
								className={`flex flex-row items-center justify-center rounded w-52 h-full px-4 bg-card_top_border`}>
								<AccountBox
									style={{ fontSize: 20 }}
									className="mr-1 h-full text-white"
								/>
								<Grid className="text-white text-sm">ชื่อหน่วยงาน</Grid>
							</Grid>
							<Grid className="pl-4 text-sm flex">
								{organizationData.companyName}
							</Grid>
						</Grid>
						{/* Address */}
						<Grid
							className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-text_field_bg`}>
							<Grid
								className={`flex flex-row items-center justify-center rounded w-52 h-full px-4 bg-card_top_border`}>
								<Home
									style={{ fontSize: 20 }}
									className="mr-1 h-full text-white"
								/>
								<Grid className="text-white text-sm">ที่อยู่</Grid>
							</Grid>
							<Grid className="pl-4 text-sm flex">
								{organizationData.companyAddress}
							</Grid>
						</Grid>

						{/* QOS Types */}
						<Grid
							className={`flex flex-row items-center rounded border border-grey-600 my-2 w-full bg-white min-h-[3rem]`}>
							<Grid
								className={`flex flex-row items-center justify-center rounded w-52 px-4 bg-card_top_border self-stretch`}>
								<Business
									style={{ fontSize: 20 }}
									className="mr-1 text-white"
								/>
								<Grid className="text-white text-sm">ประเภทรายงาน</Grid>
							</Grid>
							<Grid className="pl-4 text-sm flex flex-wrap py-2">
								{allQOSTypes
									.sort((a, b) => b.id - a.id)
									.map((qos) => (
										<FormControlLabel
											key={qos.id}
											control={
												<Checkbox
													checked={selectedQOS.includes(qos.id)}
													onChange={e => onValueChange(qos.id, 'operatorQOS')}
													name={qos.qosTypeName}
													color="primary"
												/>
											}
											label={qos.qosTypeName}
											className="mr-4"
										/>
									))}
							</Grid>
						</Grid>

						{/* IsPayphone */}
						<Grid
							className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-white`}>
							<Grid
								className={`flex flex-row items-center justify-center rounded w-80 h-full px-4 bg-card_top_border`}>
								<PhoneInTalk
									style={{ fontSize: 20 }}
									className="mr-1 h-full text-white"
								/>
								<Grid className="text-white text-sm">โทรศัพท์สาธารณะ (1.1.7)</Grid>
							</Grid>
							<Grid className="pl-4 text-sm flex items-center">
								<Checkbox
									checked={organizationData.isPayphone === 'y'}
									onChange={e => onValueChange(e.target.checked ? 'y' : 'n', 'isPayphone')}
									color="primary"
								/>
							</Grid>
						</Grid>

						{/* IsUseReport1_1_2 */}
						<Grid
							className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-white`}>
							<Grid
								className={`flex flex-row items-center justify-center rounded w-80 h-full px-4 bg-card_top_border`}>
								<PhoneInTalk
									style={{ fontSize: 20 }}
									className="mr-1 h-full text-white"
								/>
								<Grid className="text-white text-sm">ชุดข้อมูลแบบประจำที่ประเภทเสียง (1.2.X)</Grid>
							</Grid>
							<Grid className="pl-4 text-sm flex items-center">
								<Checkbox
									checked={isUseReport1_1_2}
									onChange={e => onValueChange(e.target.checked, 'isUseReport1_1_2')}
									color="primary"
								/>
							</Grid>
						</Grid>



						<Grid className="mt-3 mb-1 w-full">
							<Divider />
						</Grid>

						{/* Start Date */}
						<Grid
							className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-white`}>
							<Grid
								className={`flex flex-row items-center justify-center rounded w-80 h-full px-4 bg-card_top_border`}>
								<CalendarToday
									style={{ fontSize: 20 }}
									className="mr-1 h-full text-white"
								/>
								<Grid className="text-white text-sm">วันที่เริ่มการให้บริการ</Grid>
							</Grid>
							<Grid className="pl-4 text-sm flex items-center w-full">
								<MuiPickersUtilsProvider utils={ThaiDateFnsUtils}>
									<KeyboardDatePicker
										disableToolbar
										variant="inline"
										format="dd/MM/yyyy"
										margin="normal"
										id="date-picker-inline-start"
										value={startDate}
										onChange={(date) => setStartDate(date)}
										KeyboardButtonProps={{
											'aria-label': 'change date',
										}}
										InputProps={{ disableUnderline: true }}
									/>
								</MuiPickersUtilsProvider>
							</Grid>
						</Grid>

						{/* End Date */}
						<Grid
							className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-white`}>
							<Grid
								className={`flex flex-row items-center justify-center rounded w-80 h-full px-4 bg-card_top_border`}>
								<EventBusy
									style={{ fontSize: 20 }}
									className="mr-1 h-full text-white"
								/>
								<Grid className="text-white text-sm">วันที่หยุดการให้บริการ</Grid>
							</Grid>
							<Grid className="pl-4 text-sm flex items-center w-full">
								<MuiPickersUtilsProvider utils={ThaiDateFnsUtils}>
									<KeyboardDatePicker
										disableToolbar
										variant="inline"
										format="dd/MM/yyyy"
										margin="normal"
										id="date-picker-inline-end"
										value={endDate}
										onChange={(date) => setEndDate(date)}
										KeyboardButtonProps={{
											'aria-label': 'change date',
										}}
										InputProps={{ disableUnderline: true }}
									/>
								</MuiPickersUtilsProvider>
							</Grid>
						</Grid>

					</Grid>
				</Card>
			</Grid>

			{/* Notification Settings Card */}
			<Grid className="px-10 pb-10">
				<Card className={`border-t-4 border-card_top_border`}>
					<Grid className="flex flex-col justify-center items-start px-5">
						<Grid className="flex flex-row mt-4 items-center justify-between w-full">
							<Grid className="flex flex-row">
								<Business style={{ fontSize: 22 }} className="mr-1" />
								<Grid className="font-bold text-sm text-card_header_color">
									ข้อมูลสำหรับการแจ้งเตือน
								</Grid>
							</Grid>
						</Grid>
						<Grid className="mt-3 mb-1 w-full">
							<Divider />
						</Grid>

						{/* Email */}
						<Grid
							className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-white`}>
							<Grid
								className={`flex flex-row items-center justify-center rounded w-52 h-full px-4 bg-card_top_border`}>
								<Mail
									style={{ fontSize: 20 }}
									className="mr-1 h-full text-white"
								/>
								<Grid className="text-white text-sm">อีเมล</Grid>
							</Grid>
							<Grid className="pl-4 text-sm flex w-full pr-4">
								<TextField
									fullWidth
									size="small"
									variant="standard"
									InputProps={{ disableUnderline: true }}
									value={email}
									onChange={e => onValueChange(e.target.value, 'email')}
								/>
							</Grid>
						</Grid>

						{/* Mobile */}
						<Grid
							className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-white`}>
							<Grid
								className={`flex flex-row items-center justify-center rounded w-52 h-full px-4 bg-card_top_border`}>
								<Phone
									style={{ fontSize: 20 }}
									className="mr-1 h-full text-white"
								/>
								<Grid className="text-white text-sm">เบอร์ติดต่อ</Grid>
							</Grid>
							<Grid className="pl-4 text-sm flex w-full pr-4">
								<TextField
									fullWidth
									size="small"
									variant="standard"
									InputProps={{ disableUnderline: true }}
									value={telephone}
									onChange={e => onValueChange(e.target.value, 'telephone')}
								/>
							</Grid>
						</Grid>

						{/* SMS */}
						<Grid
							className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-white`}>
							<Grid
								className={`flex flex-row items-center justify-center rounded w-52 h-full px-4 bg-card_top_border`}>
								<Sms
									style={{ fontSize: 20 }}
									className="mr-1 h-full text-white"
								/>
								<Grid className="text-white text-sm">เบอร์รับการแจ้งเตือน</Grid>
							</Grid>
							<Grid className="pl-4 text-sm flex w-full pr-4">
								<TextField
									fullWidth
									size="small"
									variant="standard"
									InputProps={{ disableUnderline: true }}
									value={smsTelephone}
									onChange={e => onValueChange(e.target.value, 'smsTelephone')}
								/>
							</Grid>
						</Grid>

						<Grid className="flex justify-between w-full my-5">
							<Button
								variant="outlined"
								onClick={() => history.goBack()}>
								ย้อนกลับ
							</Button>
							<Button
								variant="contained"
								color="primary"
								onClick={onSubmitChange}>
								บันทึกข้อมูล
							</Button>
						</Grid>

					</Grid>
				</Card>
			</Grid>

			<SuccessModal
				title={'การเปลี่ยนแปลงข้อมูลสำเร็จ'}
				open={openSuccessModal}
				handleButton={onOpenSuccessModal}
			/>
			<FailModal
				title={'การเปลี่ยนแปลงข้อมูลไม่สำเร็จ'}
				description={failMessage}
				open={openFailModal}
				handleButton={onOpenFailModal}
			/>
		</>
	)
}
